<template>
  <v-main>
    <div class="d-flex align-center justify-space-between flex-column world-bg">
      <v-container fluid class="pt-0 auth-form"></v-container>
      <v-form class="auth-form" @submit.prevent="loginUser">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="center">
              <LogoTrinityLight routeName="Login" :width="200" class="mb-5" />
            </v-col>
            <v-col cols="12" class="pb-0 mt-12">
              <span class="bold font-8 text-white">E-mail*</span>
              <InputField
                label=""
                placeholder="Digite aqui"
                :type="'email'"
                :dense="true"
                :value="userData.email"
                :solo="true"
                v-model="userData.email"
                :required="true"
                :error="getError('email')"
                @change="validateForm"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <span class="bold font-8 text-white">Senha*</span>
              <InputField
                label=""
                placeholder="Digite aqui"
                :type="'password'"
                :dense="true"
                :value="userData.senha"
                :solo="true"
                v-model="userData.senha"
                :required="true"
                :error="getError('senha')"
                @change="validateForm"
              />
              <v-hover v-slot="{}">
                <router-link
                  :to="{ name: 'ForgotPassword' }"
                  style="color: #fff;"
                  class="d-block text-center right underline font-14 bold-text"
                >
                  Esqueci minha senha
                </router-link>
              </v-hover>
            </v-col>
            <v-col cols="12">
              <BtnAcessar :loading="loadingBtn" />
            </v-col>
            <v-col cols="12" class="center"
              style="margin-left: -8px; margin-top: 24px;"
            >
              <LogoHIconBranco
                width="120" height="36"
              />
            </v-col>
          </v-row>

        </v-container>
      </v-form>

      <div>
        <MobileStoreIcons />
      </div>

      <div class="d-block text-center mt-2 mb-2" v-if="versaoTrinityClient !== ''">
        <span class="grey--text font-14">Versão: {{ versaoTrinityClient }}</span>
      </div>
    </div>

    <v-terms-dialog :handler="termsOpen" @request-close="termsOpen = false" />

    <Snackbar />
  </v-main>
</template>

<script>
import LogoTrinityLight from '@/components/LogoTrinityLight.vue';
import VTermsDialog from '@/components/VTermsDialog.vue';
import BtnAcessar from '@/components/common/BtnAcessar.vue';
import LogoHIconBranco from '@/components/icons/IconTrustHBranco.vue';
import InputField from '@/components/misc/Input.vue';
import Snackbar from '@/components/misc/Snackbar.vue';
import MobileStoreIcons from '@/components/login/MobileStoreIcons.vue';
// eslint-disable-next-line import/no-cycle
import { disconnectSocket } from '@/services/socket-client';
import { mapActions, mapState } from 'vuex';
import * as yup from 'yup';

export default {
  name: 'LoginView',
  components: {
    LogoTrinityLight,
    VTermsDialog,
    BtnAcessar,
    Snackbar,
    InputField,
    LogoHIconBranco,
    MobileStoreIcons,
  },
  props: ['redirect'],
  computed: {
    ...mapState(['versaoTrinityClient']),
    darkTheme() {
      return this.$vuetify.theme.dark;
    },
  },
  data() {
    return {
      userData: {
        email: '',
        senha: '',
      },
      errors: [],
      termsOpen: false,
      iconEye: 'mdi-eye-off-outline',
      typePass: 'password',
      loadingBtn: false,
      counterValidation: 0,
    };
  },
  created() {
    this.toggleLoading(false);
    disconnectSocket();
  },
  methods: {
    ...mapActions(['toggleLoading']),
    ...mapActions('Auth', ['fetchTiposUsuario', 'login']),
    ...mapActions('usuario', ['fetchUsuarioTermsConditions']),
    toggleView() {
      if (this.typePass === 'password') {
        this.typePass = 'text';
        this.iconEye = 'mdi-eye-outline';
      } else {
        this.typePass = 'password';
        this.iconEye = 'mdi-eye-off-outline';
      }
    },
    async validateForm() {
      if (this.counterValidation > 1) {
        this.errors = [];

        const schema = yup.object().shape({
          email: yup.string().email('O campo deve ser um e-mail.').required('Este campo é obrigatório.'),
          senha: yup.string().required('Este campo é obrigatório.'),
        });

        try {
          await schema.validate(this.userData, {
            abortEarly: false,
          });

          return true;
        } catch (err) {
          if (err.inner) {
            this.errors = err.inner;
          } else if (err.response) {
            this.errors = [
              {
                path: 'password',
                message: err.response.data.message,
              },
            ];
          }
          return false;
        }
      } else {
        this.counterValidation += 1;

        return false;
      }
    },
    async loginUser() {
      this.toggleLoading(true);
      this.loadingBtn = true;

      if (await this.validateForm()) {
        try {
          await this.login(this.userData);

          if (this.redirect) {
            this.$router.push(this.redirect);
          } else {
            await this.fetchUsuarioTermsConditions();
            this.$router.push({ name: 'Home' });
          }
        } catch (e) {
          this.loadingBtn = false;
          this.toggleLoading(false);

          document.dispatchEvent(new CustomEvent('snack', {
            detail: {
              text: e.response.data?.message || this.$vuetify.lang.t('$vuetify.ERRO_INTERNO_SERVIDOR_LOGIN'),
            },
          }));
        }
      }

      this.loadingBtn = false;
      this.toggleLoading(false);
    },
    getError(path) {
      const error = this.errors.find((err) => err.path === path);

      if (error) {
        return error.message;
      }

      return undefined;
    },
  },
  mounted() {
    console.log(`o que você quer fazer aqui ?
  ⣠⡤⠞⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣾⣿⣇⠈⢧⡈⢻⣿⣿⣿⠀⠀⠀⠀⠀⠀⠀⢿⠉⠉⠙⢷⣸⡇⠉⠻⣧⠀⣀⣠⣬⠶⠿⠛⠋⠉⠀⠉⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣤
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢿⣿⣿⣆⠈⢷⡀⣻⡿⠛⠋⠉⠉⠉⠙⠛⠳⠾⠇⠀⠀⠀⣿⣿⡀⠀⠘⣿⠋⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣤⡤⠶⠚⠋⠉⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⢿⣿⣿⣦⢨⡿⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⠋⠀⠀⠀⠸⣇⠀⠀⠀⠀⠀⠀⣀⣀⣤⠴⠗⠛⠉⠉⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⣧⠈⠙⠛⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⣀⣤⣴⠶⠛⠋⠉⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣤⠶⠛⠀⠀⠀⠀⠀⠀⠀⣶⠶⠶⠤⢤⣀⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣰⣿⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣿⣦⣄⣀⡀⠀⠀⠀⠀⣠⣦⡉⢳⡀⠀⠀⠀⠈⠉⠙⠛⠒⠦⠤⣤⣀⣀⣰⡿⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⢀⣀⣤⡴⠶⠛⠋⠉⠀⢨⡿⠁⠀⠀⠀⠀⠈⠻⣍⠛⠻⠄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢻⣏⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⢀⣀⣤⡶⠞⠛⠉⠁⠀⠀⠀⠀⠀⠀⣸⠁⠀⠀⠀⠀⠀⠀⠀⠘⣆⠀⠀⠀⠀⠀⠀⠀⠀⠰⣄⠀⠀⠀⠀⠼⣧⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠛⠉⠁⠀⠀⠀⠀⠀⠀⣀⣀⣤⡴⠶⠛⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⡆⠀⡄⠀⠀⣀⣀⣀⣀⣈⣧⣀⣀⣤⣤⣤⣿⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⢀⣀⣤⠴⠖⠛⠋⠉⠀⠀⠀⠀⢹⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⠀⢷⣾⠿⠿⠿⠟⠛⠿⣿⣿⠒⠒⠚⠓⢺⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠶⠚⠋⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠹⣦⡀⠀⠀⣠⣾⣿⣿⣦⣿⡆⠘⠯⠀⠀⠀⠀⠀⠐⠋⠈⠳⠤⠤⣴⣏⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠶⢴⣿⠹⣿⡹⠛⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢈⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢧⣈⢛⡂⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠒⠒⠚⢻⡅⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⢻⡅⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠹⣦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢘⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢈⣷⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣨⣷⠀⠀⠀⠀⠀⠀⠀⠀⠀⠚⠉⠉⠉⢙⡿⠛⠉⠙⠛⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣾⢟⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⡾⠟⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⣾⡳⣿⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣼⣿⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
    `);
  },
};
</script>

<style>
</style>
